import type { CastProject } from '../types'

interface Props {
  projects: CastProject[]
  active: string
  onChange: (id: string) => void
}

export function ProjectSelector({ projects, active, onChange }: Props) {
  if (projects.length <= 1) {
    const p = projects[0]
    return (
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-forge-ember/10 flex items-center justify-center">
          <span className="text-forge-ember font-display font-bold text-sm">
            {p?.name?.charAt(0) || '?'}
          </span>
        </div>
        <div>
          <div className="text-sm font-semibold text-forge-primary">{p?.name}</div>
          <div className="text-[11px] text-forge-ash">{p?.description}</div>
        </div>
      </div>
    )
  }

  return (
    <select
      value={active}
      onChange={(e) => onChange(e.target.value)}
      className="bg-forge-basalt border border-forge-border text-forge-primary px-3 py-2 rounded-lg text-sm font-sans focus:outline-none focus:border-forge-ember transition-colors"
    >
      {projects.map((p) => (
        <option key={p.id} value={p.id}>
          {p.name}
        </option>
      ))}
    </select>
  )
}
